export const BRAND_NAME = 'Tsunami9';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'tsunami9.in';
export const PROVIDER_ID = 'BetFair';
